module.exports = __webpack_public_path__ + "static/img/pCT1.470b0cdd.png";